import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import toast from 'react-hot-toast';

interface Props {
  onClose: () => void;
}

export const ShopifyModal: React.FC<Props> = ({ onClose }) => {
  const [shopDomain, setShopDomain] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleInstall = () => {
    let domain = shopDomain.trim().toLowerCase();

    if (!domain) {
      toast.error('Please enter your Shopify store URL');
      return;
    }

    // Clean up domain if merchant pasted full URL or protocol
    domain = domain.replace(/^https?:\/\//, '').replace(/\/.*$/, '');

    // Append .myshopify.com if only store prefix was entered
    if (!domain.includes('.')) {
      domain = `${domain}.myshopify.com`;
    } else if (!domain.endsWith('.myshopify.com')) {
      toast.error('Please enter a valid Shopify domain (e.g. your-store.myshopify.com)');
      return;
    }

    setIsLoading(true);

    const channelUrl = process.env.REACT_APP_CHANNEL_URL || 'https://channel.parcelpicks.com';
    window.location.href = `${channelUrl}/shopify/install?shop=${encodeURIComponent(domain)}`;
  };

  return (
    <div className="flex flex-col w-full -m-6 px-6 py-6 pb-2">
      {/* Top Banner exactly spanning the width */}
      <div className="border-b border-gray-200 pb-4 mb-4 -mx-6 px-6">
        <h2 className="text-xl text-gray-600 font-medium">Connect Shopify Store</h2>
      </div>

      <div className="flex flex-col items-center justify-center py-6 text-center pt-2 max-w-md mx-auto w-full">
        <img 
          src="/brandLogos/channel/shopify.svg" 
          alt="Shopify" 
          className="h-14 mb-6 hover:opacity-90 transition-opacity"
        />
        
        <p className="text-[16px] text-gray-700 mb-4">
          Enter your Shopify store URL to connect with <strong>ParcelPicks</strong>:
        </p>

        <div className="w-full text-left mb-4">
          <Input 
            label="Shopify Store Domain"
            placeholder="your-store.myshopify.com" 
            value={shopDomain}
            onChange={(e) => setShopDomain(e.target.value)}
            disabled={isLoading}
            required
            className="w-full"
          />
        </div>

        <Button 
          onClick={handleInstall} 
          disabled={isLoading}
          variant="default"
          className="w-full font-semibold py-2.5"
        >
          {isLoading ? 'Connecting...' : 'Connect & Install App'}
        </Button>

        <p className="text-xs text-gray-500 mt-3 font-medium">
          Note: You will be redirected to Shopify App Store to authorize permissions.
        </p>
      </div>
    </div>
  );
};
